import clsx from 'clsx';
import styles from './menu-hamburger.module.css';

type Props = {
    onClick: () => void;
    isOpen?: boolean;
    isSearchPage?: boolean;
};

const MenuHamburger = ({ onClick, isOpen, isSearchPage }: Props) => {
    return (
        <button onClick={onClick} className={clsx(styles.root, 'cleanButton')} aria-label="Menu">
            <span
                className={clsx(styles.bar, {
                    [styles.open]: isOpen,
                    [styles.searchPage]: isSearchPage,
                })}
            ></span>
            <span
                className={clsx(styles.bar, {
                    [styles.open]: isOpen,
                    [styles.searchPage]: isSearchPage,
                })}
            ></span>
            <span
                className={clsx(styles.bar, {
                    [styles.open]: isOpen,
                    [styles.searchPage]: isSearchPage,
                })}
            ></span>
        </button>
    );
};

export default MenuHamburger;
